import { createRouter, createWebHashHistory } from 'vue-router'
import { getDefaultRoutePath } from '@/utils/menu'

// 定义一个白名单数组，动态生成路由
// const webSiteRouter = []
// export const webSitLists = [
//   'home',
//   'productOne',
//   'productTwo',
//   'applicationPhone',
//   'applicationMini',
//   'companyNews',
//   'contactUs',
//   'privacyPolicy',
//   'license'
// ]

// webSitLists.forEach((item) => {
//   webSiteRouter.push({
//     path: '/' + item,
//     name: item,
//     component: () => import('../views/pages/' + item)
//   })
// })

// 创建路由对象
const routes = [
  {
    path: '/home',
    name: 'home',
    component: () => import(/* webpackChunkName:"login" */ '../views/login'),
    meta: { title: '首页' }
  },

  {
    // 说明书
    path: '/shuoMingShu',
    name: 'shuoMingShu',
    component: () =>
      import(
        /* webpackChunkName:"shuoMingShu" */ '../views/shuoMingShu/index.vue'
      ),
    meta: { title: '说明书' }
  },
  {
    path: '/',
    name: '/',
    component: () => import(/* webpackChunkName:"layout" */ '../layout'),
    redirect: () => getDefaultRoutePath(),

    /**
     *注意：path 和 name 需要保持一致，不能随意修改
     *
     */
    children: [
      {
        // 首页
        path: 'homepage',
        name: 'homepage',
        component: () =>
          import(/* webpackChunkName:"homepage" */ '@/views/homepage/index.vue')
      },
      {
        // 测试
        path: 'ceshi',
        name: 'ceshi',
        component: () =>
          import(/* webpackChunkName:"ceshi" */ '@/views/ceshi/ceshi.vue')
      },
      {
        // 主页
        path: 'homepage1',
        name: 'homepage1',
        component: () =>
          import(
            /* webpackChunkName:"homepage1" */ '@/views/homepage1/index.vue'
          )
      },
      {
        path: 'chatGPT',
        name: 'chatGPT',
        component: () =>
          import(/* webpackChunkName:"chatGPT" */ '@/views/chatGPT/index.vue')
      },
      {
        // 空
        path: 'categories',
        name: 'categories',
        component: () =>
          import(
            /* webpackChunkName:"categories" */ '@/views/categories/index.vue'
          )
      },
      {
        // 商品列表
        path: 'goods',
        name: 'goods',
        component: () =>
          import(/* webpackChunkName:"goods" */ '@/views/goods/index.vue')
      },
      {
        // 售后
        path: 'afterSales',
        name: 'afterSales',
        component: () =>
          import(
            /* webpackChunkName:"afterSales" */ '@/views/afterSales/index.vue'
          )
      },
      {
        path: 'orders',
        name: 'orders',
        component: () =>
          import(/* webpackChunkName:"orders" */ '@/views/orders/index.vue')
      },
      {
        path: 'serviceOrders',
        name: 'serviceOrders',
        component: () =>
          import(
            /* webpackChunkName:"service-orders" */ '@/views/orders-service/index.vue'
          )
      },
      {
        // 用户管理
        path: 'users',
        name: 'users',
        component: () =>
          import(
            /* webpackChunkName:"device-users" */ '@/views/device/index.vue'
          )
      },
      {
        // 服务站用户
        path: 'fwz_users_infos',
        name: 'fwz_users_infos',
        component: () =>
          import(
            /* webpackChunkName:"device-fwz-users" */ '@/views/fuWuZhanYongHu/index.vue'
          )
      },
      {
        // 空
        path: 'params',
        name: 'params',
        component: () =>
          import(/* webpackChunkName:"params" */ '@/views/params/index.vue')
      },
      {
        // 空
        path: 'reports',
        name: 'reports',
        component: () =>
          import(/* webpackChunkName:"reports" */ '@/views/reports/index.vue')
      },
      {
        // 空
        path: 'rights',
        name: 'rights',
        component: () =>
          import(/* webpackChunkName:"rights" */ '@/views/rights/index.vue')
      },
      {
        // 空
        path: 'userRoles',
        name: 'userRoles',
        component: () =>
          import(/* webpackChunkName:"userRoles" */ '@/views/roles/index.vue')
      },
      {
        // 员工管理
        path: 'workers',
        name: 'workers',
        component: () =>
          import(
            /* webpackChunkName:"workers" */ '@/views/master-manage/index.vue'
          )
      },
      {
        // 服务订单列表
        path: 'orderlistServe',
        name: 'orderlistServe',
        component: () =>
          import(
            /* webpackChunkName:"orderlist-serve" */ '@/views/orderlist-serve/index.vue'
          )
      },
      {
        // 菜单管理
        path: 'menuManagement',
        name: 'menuManagement',
        component: () =>
          import(
            /* webpackChunkName:"menu-management" */ '@/views/menuManagement/index.vue'
          )
      },
      {
        // 权限管理-角色组管理
        path: 'role',
        name: 'role',
        component: () =>
          import(
            /* webpackChunkName:"jurisdiction-role" */ '@/views/jurisdiction/role/role.vue'
          ),
        children: [
          {
            path: 'role',
            name: 'role',
            component: () =>
              import(
                /* webpackChunkName:"jurisdiction-role" */ '@/views/jurisdiction/role/role.vue'
              )
          }
          // {
          //   // 权限管理
          //   path: 'Administrator',
          //   name: 'Administrator',
          //   component: () =>
          //     import(
          //       /* webpackChunkName:"roles" 管理员 */ '@/views/jurisdiction/Administrator/Administrator.vue'
          //     )
          // }
        ]
      },
      {
        // 权限管理-管理员管理
        path: 'administratorList',
        name: 'administratorList',
        component: () =>
          import(
            /* webpackChunkName:"jurisdiction-admin" */ '@/views/jurisdiction/Administrator/Administrator.vue'
          )
      },
      {
        // 权限管理-菜单规则
        path: 'menuRules',
        name: 'menuRules',
        component: () =>
          import(
            /* webpackChunkName:"jurisdiction-menuRule" */ '@/views/jurisdiction/MenuRule/MenuRule.vue'
          )
      },
      {
        // 权限管理-管理员日志
        path: 'operationLogs',
        name: 'operationLogs',
        component: () =>
          import(
            /* webpackChunkName:"jurisdiction-adminLog" */ '@/views/jurisdiction/AdministratorLog/AdministratorLog.vue'
          )
      },
      {
        // 业绩管理
        path: 'performance',
        name: 'performance',
        component: () =>
          import(
            /* webpackChunkName:"performance" */ '@/views/performance/index.vue'
          )
      },
      {
        // 引荐登录
        path: 'yjdl_records',
        name: 'yjdl_records',
        component: () =>
          import(
            /* webpackChunkName:"performance-referrer" */ '@/views/performance/referrerlogin/referrerlogin.vue'
          )
      },
      {
        // 发票管理 invoice
        path: 'fpList',
        name: 'fpList',
        component: () =>
          import(/* webpackChunkName:"invoice" */ '@/views/invoice/index.vue')
      },
      {
        // 记账中心-服务站记账
        path: 'accountServe',
        name: 'accountServe',
        component: () =>
          import(
            /* webpackChunkName:"account-serve" */ '@/views/account/newAccountServe/index.vue'
          )
      },
      {
        // 记账中心-总部记账
        path: 'headAccounts',
        name: 'headAccounts',
        component: () =>
          import(
            /* webpackChunkName:"account-head" */ '@/views/account/headAccounts/index.vue'
          )
      },
      {
        // 记账中心-服务对账管理
        path: 'financial_detail',
        name: 'financial_detail',
        component: () =>
          import(
            /* webpackChunkName:"account-financial" */ '@/views/account/financialDetail/financialDetail.vue'
          )
      },
      {
        // 运营中心-点击量统计
        path: 'clickRates',
        name: 'clickRates',
        component: () =>
          import(
            /* webpackChunkName:"operation-clickRate" */ '@/views/operation/clickRate/index.vue'
          )
      },
      {
        // 营销活动
        path: 'marketing',
        name: 'marketing',
        component: () =>
          import(
            /* webpackChunkName:"marketing" */ '@/views/marketing/index.vue'
          )
      },
      {
        // 营销 - 优惠券
        path: 'coupons',
        name: 'coupons',
        component: () =>
          import(
            /* webpackChunkName:"marketing-coupons" */ '@/views/marketing/coupons/index.vue'
          )
      },
      {
        // 营销 - 平台活动
        path: 'mallActivities',
        name: 'mallActivities',
        component: () =>
          import(
            /* webpackChunkName:"marketing-activities" */ '@/views/marketing/mallActivities/index.vue'
          )
      },
      {
        // 库存管理 - 服务站库存
        path: 'fwz_stocks',
        name: 'fwz_stocks',
        component: () =>
          import(
            /* webpackChunkName:"stocks-fwz" */ '@/views/stocks/fwzStocks/index.vue'
          )
      },
      {
        // 库存管理 - 移动货架管理
        path: 'fwz_cars',
        name: 'fwz_cars',
        component: () =>
          import(
            /* webpackChunkName:"stocks-cars" */ '@/views/stocks/fwzCars/index.vue'
          )
      },
      {
        // 打卡
        path: 'dk_info',
        name: 'dk_info',
        component: () =>
          import(/* webpackChunkName:"dk-info" */ '@/views/dk_info/index.vue')
      },
      {
        // 服务站列表 服务站账号管理
        path: 'fwz_accounts',
        name: 'fwz_accounts',
        component: () =>
          import(
            /* webpackChunkName:"account-fwz" */ '@/views/account/fwzAccounts/fwzAccounts.vue'
          )
      },
      {
        // 服务站列表 服务价格管理
        path: 'service_price_management',
        name: 'service_price_management',
        component: () =>
          import(
            /* webpackChunkName:"service-price" */ '@/views/account/servicePriceManagement/index.vue'
          )
      },
      {
        // 服务站列表 服务景观
        path: 'landscapes_management',
        name: 'landscapes_management',
        component: () =>
          import(
            /* webpackChunkName:"landscapes" */ '@/views/account/landscapesManagement/index.vue'
          )
      },

      {
        // 地图
        path: 'QQMap',
        name: 'QQMap',
        component: () =>
          import(/* webpackChunkName:"qq-map" */ '@/views/QQMap/QQMap.vue')
      },

      // 仓储中心
      {
        // 入库信息列表
        path: 'RuKuInfoList',
        name: 'RuKuInfoList',
        component: () =>
          import(
            /* webpackChunkName:"cangchu-ruku-info" */ '@/views/CangChuZhongXin/RuKu/RuKuInfoList/RuKuInfoList.vue'
          )
      },
      {
        // 入库日志
        path: 'RuKuLog',
        name: 'RuKuLog',
        component: () =>
          import(
            /* webpackChunkName:"cangchu-ruku-log" */ '@/views/CangChuZhongXin/RuKu/RuKuLog/RuKuLog.vue'
          )
      },
      {
        // 出库信息列表
        path: 'ChuKuInfoList',
        name: 'ChuKuInfoList',
        component: () =>
          import(
            /* webpackChunkName:"cangchu-chuku-info" */ '@/views/CangChuZhongXin/ChuKu/ChuKuInfoList/ChuKuInfoList.vue'
          )
      },

      {
        // 出库日志
        path: 'ChuKuLog',
        name: 'ChuKuLog',
        component: () =>
          import(
            /* webpackChunkName:"cangchu-chuku-log" */ '@/views/CangChuZhongXin/ChuKu/ChuKuLog/ChuKuLog.vue'
          )
      },

      // 【活体集采】 - 活体商品 group_goods  E:\Rame_sms\src\views\LiveBody\groupGoods\groupGoods.vue
      {
        path: 'group_goods',
        name: 'group_goods',
        component: () =>
          import(
            /* webpackChunkName:"livebody-goods" */ '@/views/LiveBody/groupGoods/groupGoods.vue'
          )
      },
      // 【活体集采】 - 活体订单 group_order
      {
        path: 'group_orders',
        name: 'group_orders',
        component: () =>
          import(
            /* webpackChunkName:"livebody-orders" */ '@/views/LiveBody/groupOrders/groupOrders.vue'
          )
      },

      {
        // 【仓储】商品管理
        path: 'rame_goods',
        name: 'rame_goods',
        component: () =>
          import(
            /* webpackChunkName:"cangchu-goods" */ '@/views/CangChuZhongXin/goods/goodsPage/goodsPage.vue'
          )
      },
      {
        // 【仓储】订单管理-订单列表
        path: 'rame_orders',
        name: 'rame_orders',
        component: () =>
          import(
            /* webpackChunkName:"cangchu-orders" */ '@/views/CangChuZhongXin/order/orderPage/orderPage.vue'
          )
      },
      {
        // 【仓储】客户管理-客户列表
        path: 'rame_customersInfo',
        name: 'rame_customersInfo',
        component: () =>
          import(
            /* webpackChunkName:"cangchu-kehu" */ '@/views/CangChuZhongXin/KeHu/KeHuList/KeHuList.vue'
          )
      }
    ]
  }
]
// routes.push(...webSiteRouter)

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
